import Logo from "../../img/logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faInstagram,
  faFacebookSquare,
} from "@fortawesome/free-brands-svg-icons";
import {
  faArrowsToCircle,
  faCar,
  faChevronRight,
  faChevronUp,
  faXmark,
  faPrint,
  faObjectGroup,
  faFileUpload,
  faMessage,
  faQuestionCircle,
  faQrcode,
  faImage,
  faMoneyBill,
  faScissors,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const socials = [
  {
    id: "Instagram",
    href: "https://www.instagram.com/3dprintingcanberra/",
    icon: faInstagram,
  },
  {
    id: "Facebook",
    href: "https://www.facebook.com/profile.php?id=100089278913559",
    icon: faFacebookSquare,
  },
];

export const menuItems = [
  { text: "Home", href: "/" },
  { text: "About", href: "/about" },
  {
    text: "Services",
    href: "/services",
    subItems: [
      { text: "Designs", text2: "Custom designs & prototyping", href: "designs", icon: faObjectGroup },
      { text: "Scanning", text2: "3D scanning of existing objects", href: "scanning", icon: faQrcode },
      { text: "Printing", text2: "In-house FDM printing services", href: "printing", icon: faPrint },
      { text: "CNC machining", text2: "High-precision CNC machining services for prototypes and production parts", href: "cnc-machining", icon: faArrowsToCircle },
      { text: "Laser cutting", text2: "Low tolerance & accurate laser cutting services", href: "laser-cutting", icon: faScissors },
      { text: "Car parts", text2: "Custom car part modifications & mounting points", href: "custom-car-parts", icon: faCar },
    ],
  },
  {
    text: "Work",
    href: "/work",
    subItems: [
      { text: "Previous Work", text2: "Hand-selected examples of our work", href: "examples", icon: faImage },
      { text: "Types of Filament", text2: "The various types of filament on offer and their use cases", href: "filament", icon: faMoneyBill },
    ],
  },
  {
    text: "Contact",
    href: "/contact",
    subItems: [
      { text: "Contact", text2: "Send us a contact message", href: "form", icon: faMessage },
      { text: "Upload", text2: "Upload a 3D model for us to print", href: "upload", icon: faFileUpload },
      { text: "FAQ", text2: "Frequently Asked Questions", href: "faq", icon: faQuestionCircle },
    ],
  },
];

const hamburgerMenuItems = [
  menuItems[0],
  menuItems[1],
  menuItems[3],
  menuItems[2],
  menuItems[4],
];

const Navbar = () => {
  return (
    <motion.div
      initial={{ opacity: 0, transform: "translateY(-50px)" }}
      whileInView={{ opacity: 1, transform: "translateY(0px)" }}
      transition={{ duration: 0.5 }}
      className="bg-white relative z-50"
      viewport={{ once: true }}
    >
      <div className="container mx-auto bg-white">
        <NavbarTop />
      </div>
      <hr />
    </motion.div>
  );
};

const NavbarTop = () => {
  const [isOpen, setOpen] = useState(false);
  const [openSection, setOpenSection] = useState(null);

  return (
    <>
      <div className="navbarContainer relative z-50 mb-5 pb-5 p-[2.5rem] flex flex-wrap items-center border-b border-white bg-white">

        <div className="flex flex-auto basis-0 group">
          <Link to="/">
            <img
              alt="logo"
              src={Logo}
              className="w-56 min-w-[200px] mr-2 group-hover:opacity-75 cursor-pointer transition ease-in-out duration-300"
            />
          </Link>
        </div>

        <div className="flex flex-auto justify-end basis-0 items-center">
          <NavbarBottom />

          <div
            onClick={() => setOpen(!isOpen)}
            className="hamburger group hover:cursor-pointer ml-6 lg:hidden"
          >
            {isOpen ? (
              <FontAwesomeIcon
                className="text-xl text-black transition ease-in-out duration-300"
                icon={faXmark}
              />
            ) : (
              <>
                <div className="h-0.5 w-6 mb-1 bg-black group-hover:bg-neutral-400 transition ease-in-out duration-300" />
                <div className="h-0.5 w-6 mb-1 bg-black group-hover:bg-neutral-400 transition ease-in-out duration-300" />
                <div className="h-0.5 w-6 mb-1 bg-black group-hover:bg-neutral-400 transition ease-in-out duration-300" />
              </>
            )}
          </div>
        </div>
      </div>

    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ y: -1000, opacity: 1 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -1000, opacity: 1 }}
          transition={{ type: "spring", stiffness: 120, damping: 20 }}
          className="absolute left-0 w-full bg-white shadow-sm z-40"
        >
          <div className="flex flex-col px-6 py-6 gap-4">
            {hamburgerMenuItems.map((menuItem) => {
              const isSectionOpen = openSection === menuItem.text;
              return (
                <div key={menuItem.text} className="text-neutral-900">
                  {menuItem.subItems ? (
                    <>
                      <button
                        onClick={() =>
                          setOpenSection(isSectionOpen ? null : menuItem.text)
                        }
                        className="w-full flex items-center justify-between font-medium"
                      >
                        {menuItem.text}
                        <FontAwesomeIcon
                          icon={faChevronUp}
                          className={`transition-transform duration-300 ${
                            isSectionOpen ? "" : "rotate-180"
                          }`}
                        />
                      </button>

                      <div
                        className={`overflow-hidden transition-all duration-300 ${
                          isSectionOpen
                            ? "max-h-[600px] opacity-100 mt-2"
                            : "max-h-0 opacity-0"
                        }`}
                      >
                        <div className="flex flex-col pl-4 gap-3">
                          {menuItem.subItems.map((subItem) => (
                            <Link
                              key={subItem.text}
                              to={`${menuItem.href}/${subItem.href}`}
                              onClick={() => setOpen(false)}
                              className="flex items-center gap-3"
                            >
                              <FontAwesomeIcon
                                className="text-xl text-main w-6"
                                icon={subItem.icon}
                              />
                              <div>
                                <h3 className="font-medium">{subItem.text}</h3>
                                <h4 className="text-neutral-500 text-sm">
                                  {subItem.text2}
                                </h4>
                              </div>
                            </Link>
                          ))}
                        </div>
                      </div>
                    </>
                  ) : (
                    <Link
                      to={menuItem.href}
                      onClick={() => setOpen(false)}
                      className="font-medium"
                    >
                      {menuItem.text}
                    </Link>
                  )}
                </div>
              );
            })}

            <div className="flex gap-6 mt-6">
              {socials.map((social) => (
                <a
                  key={social.id}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xl text-neutral-700 hover:text-main transition-colors"
                >
                  <FontAwesomeIcon icon={social.icon} />
                </a>
              ))}
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>

    </>
  );
};

const NavbarBottom = () => {
  return (
    <div className="hidden lg:flex flex-column space-between items-center mr-12">
      <div className="flex grow justify-end space-x-12 items-center">
        {menuItems.map((menuItem) => (
          <span key={menuItem.text} className="group relative">
            <Link
              className="hover:text-neutral-400 text-neutral-600 font-medium"
              to={menuItem.subItems ? "" : menuItem.href}
            >
              {menuItem.text}
            </Link>

            {menuItem.subItems && (
              <div className="menu absolute right-0 z-10">
                <div className="h-4 bg-transparent hidden group-hover:block" />
                <div className="p-6 bg-white text-neutral-700 shadow-xl rounded-lg border border-gray hidden group-hover:block">
                  <h5 className="text-neutral-500 text-xs font-bold mb-2 uppercase">
                    {menuItem.text}
                  </h5>
                  {menuItem.subItems.map((subItem) => (
                    <Link
                      key={subItem.text}
                      className="navItem"
                      to={`${menuItem.href}/${subItem.href}`}
                      replace
                    >
                      <div className="p-4 mb-2 rounded-md flex justify-between items-center">
                        <div className="flex items-center">
                          <FontAwesomeIcon
                            className="text-xl w-6 mr-4 text-main"
                            icon={subItem.icon}
                          />
                          <div>
                            <h4 className="font-medium">{subItem.text}</h4>
                            <h3 className="text-neutral-400">{subItem.text2}</h3>
                          </div>
                        </div>
                        <FontAwesomeIcon icon={faChevronRight} />
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </span>
        ))}

        <span className="none lg:flex">
          <Link
            to="/upload"
            className="rounded-full font-mono uppercase text-sm bg-main text-white p-3 w-52 text-center"
          >
            <FontAwesomeIcon className="mr-2" icon={faFileUpload} />
            Upload a model
          </Link>
        </span>
      </div>
    </div>
  );
};

export default Navbar;
